import React from "react";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Paper from "@material-ui/core/Paper";
import Switcher from "./switcherApp";

export default function FullWidthTabs(props) {
  const [value, setValue] = React.useState(0);

  function handleChange(event, newValue) {
    setValue(newValue);
  }

  return (
    <div>
      <Paper square>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="secondary"
          textColor="primary"
          variant="fullWidth"
          aria-label="full width tabs example"
        >
          <Tab label="Informacion General" onClick={() => setValue(0)} />
          <Tab label="Etapa 1 Reclm. Directa" onClick={() => setValue(1)} />
          <Tab label="Etapa 2 Reclm. Admin." onClick={() => setValue(2)} />
          <Tab label="Etapa 3 Demanda Judicial" onClick={() => setValue(3)} />
        </Tabs>
      </Paper>
      <Switcher
        index={value}
        selectedNote={props.selectedNote}
        noteUpdate={props.noteUpdate}
        selectedNoteIndex={props.selectedNoteIndex}
        datosAutoc={props.datosAutoc}
        notes={props.notes}
        usuarios={props.usuarios}
      />
    </div>
  );
}
